"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeterReadingsTable = exports.mapToTableData = void 0;
var react_1 = __importStar(require("react"));
var core_1 = require("../../../../shared/core");
var MeterReadingsContext_1 = require("../../MeterReadingsContext");
var constants_1 = require("../../constants");
var copy_1 = require("../../copy");
var utils_1 = require("../../utils");
var MeterReadingsQuery_1 = require("../MeterReadingsData/MeterReadingsQuery");
var MeterReadingsTable_styled_1 = require("./MeterReadingsTable.styled");
var MeterReadingsTableEntry_1 = require("./MeterReadingsTableEntry");
var mapToTableData = function (fuel, meterNumOfDigits) { return function (reading) {
    var type = (0, utils_1.getReadingTypeLabel)(reading.readingType) || 'Other';
    var leadingZeros = function (value) {
        return (0, utils_1.applyLeadingZeros)(meterNumOfDigits, value);
    };
    if (fuel === 'electricity') {
        var elecReading_1 = reading;
        if (!elecReading_1.tiers) {
            throw new Error('Expected tiers for electricity fuel type, but none was given');
        }
        else if (elecReading_1.tiers.length === 1) {
            return [
                {
                    isMulti: false,
                    fuel: fuel,
                    type: type,
                    readingDateTime: elecReading_1.readingDateTime,
                    reading: leadingZeros(elecReading_1.tiers[0].meterRegisterReading),
                    register: elecReading_1.tiers[0].timeOfUseLabel,
                },
            ];
        }
        else {
            return elecReading_1.tiers.map(function (tier) { return ({
                isMulti: true,
                fuel: fuel,
                register: tier.timeOfUseLabel,
                readingDateTime: elecReading_1.readingDateTime,
                type: type,
                reading: leadingZeros(tier.meterRegisterReading),
            }); });
        }
    }
    else {
        var gasReading = reading;
        return [
            {
                isMulti: false,
                fuel: fuel,
                type: type,
                readingDateTime: gasReading.readingDateTime,
                reading: leadingZeros(gasReading.gasVolume),
            },
        ];
    }
}; };
exports.mapToTableData = mapToTableData;
var MeterReadingFragment = function (_a) {
    var _b;
    var selectedFuel = _a.selectedFuel, hideEstimates = _a.hideEstimates, supplyIndex = _a.supplyIndex, isComplex = _a.isComplex;
    var _c = (0, core_1.useComponents)(), SecondaryCTAButton = _c.SecondaryCTAButton, Margin = _c.Margin, DataTable = _c.DataTable, TableRow = _c.TableRow, TableHeader = _c.TableHeader, TableHead = _c.TableHead, TableBody = _c.TableBody, SummaryList = _c.SummaryList, SummaryItem = _c.SummaryItem, Pii = _c.Pii;
    var _d = (0, core_1.useCopy)(copy_1.defaultOptions), Copy = _d.Copy, copy = _d.copy;
    var width = (0, utils_1.useWindowDimensions)().width;
    var isMobile = width < 768;
    var _e = __read((0, react_1.useState)(constants_1.PAGE_SIZE), 2), meterReadingsVisible = _e[0], setMeterReadingsVisible = _e[1];
    var _f = __read((0, react_1.useState)(null), 2), lastItemBeforeShowMore = _f[0], setLastItemBeforeShowMore = _f[1];
    var _g = (0, react_1.useContext)(MeterReadingsContext_1.MeterReadingsContext), readings = _g.readings, supplies = _g.supplies;
    var supply = (0, utils_1.getSupplyMeterInfo)(supplies, selectedFuel, supplyIndex);
    var filteredReadings = (0, react_1.useMemo)(function () {
        var supplyReads = supply
            ? (0, utils_1.filterReadsMPXN)(readings[selectedFuel], supply.mpxn)
            : readings[selectedFuel];
        return hideEstimates && supply
            ? supplyReads.filter(function (_a) {
                var readingType = _a.readingType;
                return (0, utils_1.getReadingTypeLabel)(readingType) != 'Estimated';
            })
            : supplyReads;
    }, [hideEstimates, supply, readings, selectedFuel]);
    var meterNumOfDigits = supply === null || supply === void 0 ? void 0 : supply.meterNumOfDigits;
    (0, react_1.useEffect)(function () {
        if (lastItemBeforeShowMore && lastItemBeforeShowMore.nextSibling) {
            lastItemBeforeShowMore.nextSibling.focus();
            setLastItemBeforeShowMore(null);
        }
    }, [lastItemBeforeShowMore]);
    var showMoreReadings = function () {
        setLastItemBeforeShowMore(document.querySelector('#meter-readings-table tbody tr:last-of-type'));
        setMeterReadingsVisible(Math.min(meterReadingsVisible + constants_1.PAGE_SIZE, filteredReadings.length));
    };
    var tableData = (_b = [])
        .concat.apply(_b, __spreadArray([], __read(filteredReadings.map((0, exports.mapToTableData)(selectedFuel, meterNumOfDigits))), false)).slice(0, meterReadingsVisible);
    var showUnsupportedMessage = !!(isComplex && meterReadingsVisible >= MeterReadingsQuery_1.KAPI_PAGINATION_LIMIT);
    var showRegisterLabel = (selectedFuel === 'electricity' && (isComplex || (supply === null || supply === void 0 ? void 0 : supply.isMultiRate))) ||
        false;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        !!supply && supplies[selectedFuel].length > 1 && (react_1.default.createElement(SummaryList, null,
            react_1.default.createElement(SummaryItem, { "data-testid": "meter-reading-history_mpxn", label: selectedFuel === 'gas'
                    ? copy('summarySupplyPointSerialGas')
                    : copy('summarySupplyPointSerialElec') },
                react_1.default.createElement(Pii, null, supply.mpxn)))),
        react_1.default.createElement(DataTable, { "data-testid": "meter-readings-table", id: "meter-readings-table" },
            isMobile ? (react_1.default.createElement(TableHead, null,
                react_1.default.createElement(TableRow, null,
                    react_1.default.createElement(TableHeader, null,
                        react_1.default.createElement(Copy, { copyKey: "historyTableDate" })),
                    react_1.default.createElement(MeterReadingsTable_styled_1.ReadingColTh, { as: TableHeader },
                        react_1.default.createElement(Copy, { copyKey: "historyTableReading" }))))) : (react_1.default.createElement(TableHead, null,
                react_1.default.createElement(TableRow, null,
                    react_1.default.createElement(TableHeader, null,
                        react_1.default.createElement(Copy, { copyKey: "historyTableDate" })),
                    showRegisterLabel ? (react_1.default.createElement(TableHeader, null,
                        react_1.default.createElement(Copy, { copyKey: "historyTableRegister" }))) : null,
                    react_1.default.createElement(MeterReadingsTable_styled_1.ReadingColTh, { as: TableHeader },
                        react_1.default.createElement(Copy, { copyKey: "historyTableReading" })),
                    !isMobile && (react_1.default.createElement(TableHeader, null,
                        react_1.default.createElement(Copy, { copyKey: "historyTableType" })))))),
            react_1.default.createElement(MeterReadingsTable_styled_1.StyledTableBody, { as: TableBody }, tableData.map(function (data, i) { return (react_1.default.createElement(MeterReadingsTableEntry_1.MeterReadingsTableEntry, { key: i, data: data, isMobile: isMobile, showRegisterLabel: showRegisterLabel })); }))),
        meterReadingsVisible < filteredReadings.length && (react_1.default.createElement(Margin, { top: 6 },
            react_1.default.createElement(SecondaryCTAButton, { "data-testid": "meter-readings-table_show-more", onClick: showMoreReadings },
                react_1.default.createElement(Copy, { copyKey: "historyTableShowMore" })))),
        showUnsupportedMessage && react_1.default.createElement(Copy, { copyKey: "historyTableLimit" })));
};
var MeterReadingsTable = function (_a) {
    var selectedFuel = _a.selectedFuel, hideEstimates = _a.hideEstimates;
    var Copy = (0, core_1.useCopy)(copy_1.defaultOptions).Copy;
    var _b = (0, react_1.useContext)(MeterReadingsContext_1.MeterReadingsContext), readings = _b.readings, supplies = _b.supplies;
    var isComplex = (0, utils_1.hasComplexSuppliesContext)(supplies.electricity);
    var search = window.location.search;
    var supplyIndex = (0, core_1.getValueFromQueryParams)('supplyIndex', search);
    if (readings[selectedFuel].length === 0) {
        return react_1.default.createElement(Copy, { copyKey: "historyNoMeterReadings" });
    }
    return (react_1.default.createElement(MeterReadingFragment, { selectedFuel: selectedFuel, hideEstimates: hideEstimates, supplyIndex: supplyIndex ? parseInt(supplyIndex) : undefined, isComplex: isComplex }));
};
exports.MeterReadingsTable = MeterReadingsTable;
